import { useMutation, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import { chatApi } from "../../api/chat";
import { PinMessageRequest } from "../../types/sendMessage";

/**
 * Hook để ghim hoặc bỏ ghim tin nhắn
 * @param roomId - ID phòng chat
 * @returns Mutation object với hàm pinMessage
 */
export const usePinMessage = (roomId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: PinMessageRequest) => {
      const response = await chatApi.pinMessage(body);
      return response;
    },

    onSuccess: async (_data, variables) => {
      message.success(_data.StatusCode === 200 && variables.pin ? "Đã ghim tin nhắn" : "Đã bỏ ghim tin nhắn");
      await queryClient.invalidateQueries({ queryKey: ["pinned-messages", roomId] });
      await queryClient.invalidateQueries({ queryKey: ["pinned-message-ids", roomId] });
      // Also invalidate the key used by System B to ensure cross-module consistency
      await queryClient.invalidateQueries({ queryKey: ["message", "pin-message-id", { roomId }] });
    },
  });
};
